"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _ErrorVisualizer = require("./ErrorVisualizer.options");

var _ErrorVisualizer2 = require("./ErrorVisualizer.styles");

var ErrorVisualizer = function ErrorVisualizer(_ref) {
  var imagePaths = _ref.imagePaths,
      baseUrl = _ref.baseUrl,
      errorToDisplay = _ref.errorToDisplay,
      className = _ref.className,
      visualizationCallback = _ref.visualizationCallback;
  return /*#__PURE__*/_react["default"].createElement(_ErrorVisualizer2.StyledVisualizer, {
    className: className,
    "data-id": "visualizer"
  }, /*#__PURE__*/_react["default"].createElement(_ErrorVisualizer2.StyledVisualizerRatioBox, {
    ratio: {
      width: 35,
      height: 31
    }
  }, /*#__PURE__*/_react["default"].createElement(_ErrorVisualizer2.StyledImage, {
    src: "".concat(baseUrl, "/").concat(imagePaths[errorToDisplay]),
    alt: "Visualization Not Setup",
    onLoad: function onLoad() {
      return visualizationCallback({
        loaded: true
      });
    }
  })));
};

ErrorVisualizer.defaultProps = {
  imagePaths: _ErrorVisualizer.defaultFilePaths,
  baseUrl: 'https://www.blinds.com/is/image/blinds',
  errorToDisplay: _ErrorVisualizer.BLANK_FILE,
  className: null,
  visualizationCallback: _noop2["default"]
};
ErrorVisualizer.propTypes = {
  /** Images to show in certain error states. */
  imagePaths: (0, _propTypes.shape)({}),

  /** Base url used to serve images to the visualizer */
  baseUrl: _propTypes.string,

  /** Visualization Image to render without arguments */
  errorToDisplay: (0, _propTypes.oneOf)([_ErrorVisualizer.BLANK_FILE, _ErrorVisualizer.NO_PREVIEW_FILE, _ErrorVisualizer.NOT_AVAILABLE_FILE]),

  /** Custom class to be added to the container */
  className: _propTypes.string,

  /** Callback for when viewer interaction or state needs to update the container */
  visualizationCallback: _propTypes.func
};
ErrorVisualizer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ErrorVisualizer",
  "props": {
    "imagePaths": {
      "defaultValue": {
        "value": "defaultFilePaths",
        "computed": true
      },
      "description": "Images to show in certain error states.",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "baseUrl": {
      "defaultValue": {
        "value": "'https://www.blinds.com/is/image/blinds'",
        "computed": false
      },
      "description": "Base url used to serve images to the visualizer",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "errorToDisplay": {
      "defaultValue": {
        "value": "BLANK_FILE",
        "computed": true
      },
      "description": "Visualization Image to render without arguments",
      "type": {
        "name": "enum",
        "value": [{
          "value": "import { BLANK_FILE, defaultFilePaths, NO_PREVIEW_FILE, NOT_AVAILABLE_FILE } from './ErrorVisualizer.options';",
          "computed": true
        }, {
          "value": "import { BLANK_FILE, defaultFilePaths, NO_PREVIEW_FILE, NOT_AVAILABLE_FILE } from './ErrorVisualizer.options';",
          "computed": true
        }, {
          "value": "import { BLANK_FILE, defaultFilePaths, NO_PREVIEW_FILE, NOT_AVAILABLE_FILE } from './ErrorVisualizer.options';",
          "computed": true
        }]
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "visualizationCallback": {
      "defaultValue": {
        "value": "noop",
        "computed": true
      },
      "description": "Callback for when viewer interaction or state needs to update the container",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};

var _default = (0, _styledComponents.withTheme)(ErrorVisualizer);

exports["default"] = _default;